module.exports = __webpack_public_path__ + "static/media/43.5b93f327.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/43.jpg
// module id = 576
// module chunks = 0